export const ARTICLES = []
